"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorCatalogProduct = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const routes_1 = require("../../routes");
const getDistributorCatalogProduct = (client) => async (params) => {
    const response = await client
        .get(routes_1.ENDPOINTS.GET_ONE_PARTNER_CATALOG_PRODUCT.applyParams(params))
        .catch((error) => {
        if (error instanceof axios_client_1.HttpError) {
            if (error.status === 422) {
                return { data: null };
            }
        }
        throw error;
    });
    return response.data;
};
exports.getDistributorCatalogProduct = getDistributorCatalogProduct;
